import { render, staticRenderFns } from "./CCMRecordAdd.vue?vue&type=template&id=343892a4"
import script from "./CCMRecordAdd.vue?vue&type=script&lang=js"
export * from "./CCMRecordAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports